import React from 'react';

interface LoginRequiredModalProps {
  isOpen: boolean;
  onClose?: () => void;
  loginUrl?: string;
  force?: boolean; // when true, cannot be dismissed
}

const LoginRequiredModal: React.FC<LoginRequiredModalProps> = ({ isOpen, onClose, loginUrl = 'https://takagi-global.com/', force = true }) => {
  if (!isOpen) return null;

  const handleLogin = () => {
    window.open(loginUrl, '_blank', 'noopener,noreferrer');
    if (!force && onClose) onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={force ? undefined : onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className="relative z-10 w-[90%] max-w-md rounded-lg bg-white p-6 shadow-xl" role="dialog" aria-modal="true">
        <h2 className="text-xl font-semibold mb-3">Login required</h2>
        <p className="text-gray-700 mb-6">
          Access information not found. Please log in on the Takagi website to continue.
        </p>
        <div className="flex items-center justify-end gap-3">
          {!force && (
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Close
            </button>
          )}
          <button
            type="button"
            onClick={handleLogin}
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal;
